import { render, staticRenderFns } from "./exchangeInfo.vue?vue&type=template&id=5a33bf7e&scoped=true&"
import script from "./exchangeInfo.vue?vue&type=script&lang=js&"
export * from "./exchangeInfo.vue?vue&type=script&lang=js&"
import style0 from "./exchangeInfo.vue?vue&type=style&index=0&id=5a33bf7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33bf7e",
  null
  
)

export default component.exports